import { useQuery } from '@tanstack/react-query';
import { Urls } from '../Urls';
import axios from '../Axios';
import { useAppContext } from '../Context/AppContext';

export const useUserGroupDetails = () => {
  const { transporterInfo } = useAppContext();

  const hasTransporterLoaded =
    transporterInfo !== undefined && transporterInfo !== null;

  const groupName = transporterInfo?.policy?.group || 'default';

  return useQuery({
    queryKey: ['user-group-details', groupName],
    queryFn: async () => {
      const response = await axios.get(
        `${Urls.Transporter.Settings}?setting_type=policy&application=TPMP&group=${groupName}`
      );
      return response.data?.response || [];
    },
    enabled: hasTransporterLoaded,
    staleTime: 5 * 60 * 1000,
  });
};